import { SelfScheduleContext } from "context/SelfScheduleContext";
import { useContext } from "react";

function useSelfScheduleContext() {
    return useContext(SelfScheduleContext);
}

export default useSelfScheduleContext;